export default __webpack_public_path__ + "static/media/base-report4.9ade73a5.png";